import "@features/graph/node/GraphNode.css"
import { EdgeProps, getStraightPath } from "reactflow"
import { FunctionComponent } from "react"
import { graphEdgeSelectionStyle } from "@features/graph/node/style/graphEdgeSelectionStyle"
import { GraphSelectionModel } from "@features/graph/graphViewModel"

const lineStyleFn = getStraightPath
const wid = 6

export const GraphBaseEdge: FunctionComponent<EdgeProps> = (props: EdgeProps) => {
  const [edgePath, labelX, labelY] = lineStyleFn({
    sourceX: props.sourceX,
    sourceY: props.sourceY,
    targetX: props.targetX,
    targetY: props.targetY,
  })
  let className = "gnc-edge"
  if (
    GraphSelectionModel.childEdges.has(props.id) ||
    GraphSelectionModel.parentEdges.has(props.id)
  ) {
    className = graphEdgeSelectionStyle(props.id)
  }

  const parent_arrow = (
    <defs>
      <marker
        id={"arrow_parent" + props.id}
        viewBox={`0 0 ${wid * 2} ${wid * 2}`}
        refX={`${wid}`}
        refY={`${wid}`}
        markerWidth={`${wid}`}
        markerHeight={`${wid}`}
        className={"gnc-edge-parent-marker"}
        orient="auto-start-reverse"
      >
        <path d={`M 0 0 L ${wid * 2} ${wid} L 0 ${wid * 2} z`} />
      </marker>
    </defs>
  )

  const child_arrow = (
    <defs>
      <marker
        id={"arrow_child" + props.id}
        viewBox={`0 0 ${wid * 2} ${wid * 2}`}
        refX={`${wid}`}
        refY={`${wid}`}
        markerWidth={`${wid}`}
        markerHeight={`${wid}`}
        className={"gnc-edge-child-marker"}
        orient="auto-start-reverse"
      >
        <path d={`M 0 0 L ${wid * 2} ${wid} L 0 ${wid * 2} z`} />
      </marker>
    </defs>
  )

  const normal_arrow = (
    <defs>
      <marker
        id={"arrow_normal" + props.id}
        viewBox={`0 0 ${wid * 2 + 1} ${wid * 2 + 1}`}
        refX={`${wid}`}
        refY={`${wid}`}
        markerWidth={`${wid}`}
        markerHeight={`${wid}`}
        className={"gnc-edge-normal-marker"}
        orient="auto-start-reverse"
      >
        <path d={`M 0 0 L ${wid * 2} ${wid} L 0 ${wid * 2} z`} />
      </marker>
    </defs>
  )

  const classNameArrow =
    className == "gnc-edge-parent"
      ? "url(#arrow_parent" + props.id + ")"
      : className == "gnc-edge-child"
      ? "url(#arrow_child" + props.id + ")"
      : "url(#arrow_normal" + props.id + ")"
  return (
    <>
      {parent_arrow}
      {child_arrow}
      {normal_arrow}
      <path
        d={edgePath}
        id={props.id}
        style={props.style}
        fill="none"
        className={className}
        markerEnd={classNameArrow}
      />
    </>
  )
}

export const GraphOtherEdge: FunctionComponent<EdgeProps> = (props: EdgeProps) => {
  const [edgePath, labelX, labelY] = lineStyleFn({
    sourceX: props.sourceX,
    sourceY: props.sourceY,
    targetX: props.targetX,
    targetY: props.targetY,
  })

  const table_arrow = (
    <defs>
      <marker
        id={"arrow_table" + props.id}
        viewBox={`0 0 ${wid * 2} ${wid * 2}`}
        refX={`${wid}`}
        refY={`${wid}`}
        markerWidth={`${wid}`}
        markerHeight={`${wid}`}
        className={"gnc-edge-table-marker"}
        orient="auto-start-reverse"
      >
        <path d={`M 0 0 L ${wid * 2} ${wid} L 0 ${wid * 2} z`} />
      </marker>
    </defs>
  )

  let className = "gnc-edge-table"
  if (
    GraphSelectionModel.childEdges.has(props.id) ||
    GraphSelectionModel.parentEdges.has(props.id)
  ) {
    className = graphEdgeSelectionStyle(props.id)
  }

  const classNameArrow = "url(#arrow_table" + props.id + ")"
  return (
    <>
      {table_arrow}
      <path
        d={edgePath}
        id={props.id}
        style={props.style}
        fill="none"
        className={className}
        markerEnd={classNameArrow}
      />
    </>
  )
}
